var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2618_7462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3289 10.4385H15.0455C14.9513 10.4385 14.8743 10.5155 14.8743 10.6096V13.9037H2.12567V10.6096C2.12567 10.5155 2.04866 10.4385 1.95455 10.4385H0.671123C0.577005 10.4385 0.5 10.5155 0.5 10.6096V14.8449C0.5 15.2235 0.805882 15.5294 1.18449 15.5294H15.8155C16.1941 15.5294 16.5 15.2235 16.5 14.8449V10.6096C16.5 10.5155 16.423 10.4385 16.3289 10.4385Z",
    fill: "#4A4A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57612 0.487982C8.59947 0.499357 8.61992 0.515898 8.63593 0.536352L11.0317 3.56951C11.1194 3.68074 11.0402 3.84544 10.8969 3.84544L9.31614 3.84544L9.31614 11.0818C9.31614 11.1759 9.23914 11.2529 9.14502 11.2529L7.8616 11.2529C7.76748 11.2529 7.69047 11.1759 7.69047 11.0818L7.69047 3.8433L6.10545 3.8433C5.96213 3.8433 5.88299 3.6786 5.97069 3.56737L8.36641 0.536352C8.38242 0.515898 8.40287 0.499357 8.42622 0.487982C8.44957 0.476606 8.4752 0.470695 8.50117 0.470695C8.52714 0.470695 8.55277 0.476606 8.57612 0.487982Z",
    fill: "#4A4A68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2618_7462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f30891a50254a0d789b3daecdff5d079.svg";
export { ForwardRef as ReactComponent };